export default "__VITE_ASSET__DaiDofIm__"